import { render } from "./RecoverPass.vue?vue&type=template&id=340f041c"
import script from "./RecoverPass.vue?vue&type=script&lang=js"
export * from "./RecoverPass.vue?vue&type=script&lang=js"

import "./RecoverPass.vue?vue&type=style&index=0&id=340f041c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__